import React, { useLayoutEffect, useRef }  from "react";
import home from "../../../../common/assets/data/home";
import { useState } from "react";
import Container from "../../../utility/ui-components/container";
import Section from "../../../utility/ui-components/section";
import SectionHeading from "../../../utility/ui-components/sectionHeading";
import emailjs from "@emailjs/browser";

function ContactSection() {
  const form = useRef();
  const [success, setSuccess] = useState(false);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_ugb811d",
        "template_h075pqn",
        form.current,
        "Vx7bgp5UFBysNdjcH"
      )
      .then(
        (result) => {
          if (result.text === 'OK') {
            setSuccess(true);
            e.target.reset();
            setTimeout(() => {
              setSuccess(false);
            }, 5000);
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  const data = home.contactsection;
  const data1 = home.socialMedia;
  window.scrollTo(0, 0);
  return (
    <Section>
      <Container>
        <div className="bg-white rounded">
          <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            <div className="p-8 grid self-stretch gap-4 bg-secondary text-white rounded h-100">
              <SectionHeading heading={data.Heading} />
              {data.sectionListItems.map((items, index) => (
                <div
                  key={index + 1}
                  className="flex items-center justify-start gap-4"
                >
                  <div className="flex grow-0 items-center justify-center w-[40px] h-[40px] rounded-full bg-primary">
                    <img
                      className="grow-0 w-[24px] h-[24px] rounded-lg"
                      src={items.image}
                      alt="icons"
                    />
                  </div>
                  <div className="grow-1">
                    <h5 className="mb-1 font-bold text-lg">{items.heading}</h5>
                    <p>{items.paragraph}</p>
                    <p>{items.paragraph1}</p>
                  
                  </div>
                </div>
              ))}
              {/* <h5>Social Media</h5>
                <div className="flex">
                  {data1.sectionListItems.map((list, index) => (
                    <div key={index + 1} className="w-5 mr-3">
                      <img src={list.image} />
                    </div>
                  ))}
                </div> */}
            </div>
            <div className="lg:col-span-2">
              <div className="container">
                <h2 className=" text-3xl text-center md:text-left md:text-4xl font-bold capitalize my-3">
                  Reach Us
                </h2>
                <form
                  ref={form}
                  onSubmit={sendEmail}
                  method="post"
                  id="contact-form"
                  data-toggle="validator"
                >
                <div className="grid gap-5 gap-y-4 text-sm grid-cols-1 md:grid-cols-5">
                  <div className="md:col-span-3">
                    <label for="full_name">First Name</label>
                    <input
                      type="text"
                      name="full_name"
                      id="full_name"
                      className="h-10 border mt-1 rounded px-4 w-full bg-gray-50"
                     
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label for="full_name">Last Name</label>
                    <input
                      type="text"
                      name="full_name"
                      id="full_name"
                      className="h-10 border mt-1 rounded px-4 w-full bg-gray-50"
                    
                    />
                  </div>

                  <div className="md:col-span-5">
                    <label for="email">Email Address</label>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      className="h-10 border mt-1 rounded px-4 w-full bg-gray-50"
                    
                      placeholder="email@domain.com"
                    />
                  </div>

                  <div className="md:col-span-5">
                    <label for="address">Description</label>
                    <textarea
                      type="text"
                      name="address"
                      id="address"
                      className="h-20 border mt-1 rounded px-4 w-full bg-gray-50"
                    
                      placeholder=""
                    />
                  </div>

                  {/* <div className="md:col-span-2">
                    <label for="city">City</label>
                    <input
                      type="text"
                      name="city"
                      id="city"
                      className="h-10 border mt-1 rounded px-4 w-full bg-gray-50"
                      value=""
                      placeholder=""
                    />
                  </div> */}

                  {/* <div className="md:col-span-2">
                    <label for="country">Country / region</label>
                    <div className="h-10 bg-gray-50 flex border border-gray-200 rounded items-center mt-1">
                      <input
                        name="country"
                        id="country"
                        placeholder="Country"
                        className="px-4 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        value=""
                      />
                      <button
                        tabindex="-1"
                        className="cursor-pointer outline-none focus:outline-none transition-all text-gray-300 hover:text-red-600"
                      >
                        <svg
                          className="w-4 h-4 mx-2 fill-current"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                      </button>
                      <button
                        tabindex="-1"
                        for="show_more"
                        className="cursor-pointer outline-none focus:outline-none border-l border-gray-200 transition-all text-gray-300 hover:text-blue-600"
                      >
                        <svg
                          className="w-4 h-4 mx-2 fill-current"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <polyline points="18 15 12 9 6 15"></polyline>
                        </svg>
                      </button>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <label for="state">State / province</label>
                    <div className="h-10 bg-gray-50 flex border border-gray-200 rounded items-center mt-1">
                      <input
                        name="state"
                        id="state"
                        placeholder="State"
                        className="px-4 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        value=""
                      />
                      <button
                        tabindex="-1"
                        className="cursor-pointer outline-none focus:outline-none transition-all text-gray-300 hover:text-red-600"
                      >
                        <svg
                          className="w-4 h-4 mx-2 fill-current"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                      </button>
                      <button
                        tabindex="-1"
                        for="show_more"
                        className="cursor-pointer outline-none focus:outline-none border-l border-gray-200 transition-all text-gray-300 hover:text-blue-600"
                      >
                        <svg
                          className="w-4 h-4 mx-2 fill-current"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <polyline points="18 15 12 9 6 15"></polyline>
                        </svg>
                      </button>
                    </div>
                  </div>

                  <div className="md:col-span-1">
                    <label for="zipcode">Zipcode</label>
                    <input
                      type="text"
                      name="zipcode"
                      id="zipcode"
                      className="transition-all flex items-center h-10 border mt-1 rounded px-4 w-full bg-gray-50"
                      placeholder=""
                      value=""
                    />
                  </div>

                  <div className="md:col-span-5">
                    <div className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="billing_same"
                        id="billing_same"
                        className="form-checkbox"
                      />
                      <label for="billing_same" className="ml-2">
                        I'd like to receive more information about company. I
                        understand and agree to the Privacy policy
                      </label>
                    </div>
                  </div> */}
                </div>
                <div className="items-center">
                  <button className="border-white rounded font-bold  text-white h-10 border mt-1  w-full bg-secondary mt-3 m-auto">
                    Submit
                  </button>
                </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
export default ContactSection;
